import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useHistory, useLocation } from 'react-router';
import RouteUtils from '../../../modules/routeUtils';
import { useGetFoodCategoriesQuery } from '../../../redux/slices/foodCategorySlice';

import styles from './FilterList.module.postcss';

dayjs.extend(utc);
dayjs.extend(timezone);

function FilterItem({ name, onRemoveFilter }) {
  return (
    <div className={styles.FilterList_item}>
      {name}
      <span onClick={onRemoveFilter}>×</span>
    </div>
  );
}

function FilterList({ query, day, foodCategories, openNow, tomorrow }) {
  const location = useLocation();
  const history = useHistory();
  const filterList = [];

  const { data = {} } = useGetFoodCategoriesQuery();
  const allCategories = data.food_categories || [];

  const setFilters = (params) => {
    RouteUtils.updateQueryParam(
      history,
      location,
      params,
    );
  };

  const getFoodCategoryName = (id) => {
    return allCategories.find((c) => c.id === id)?.name || id;
  };

  if (query) {
    filterList.push(
      <FilterItem
        name={query}
        onRemoveFilter={() => setFilters({ query: null, page: null })}
        key={`query-${query}`}
      />
    );
  }

  // Food categories (handles both single and multiple)
  if (foodCategories) {
    const categoriesArray = foodCategories.split(',').map(c => c.trim());
    categoriesArray.forEach((category) => {
      filterList.push(
        <FilterItem
          name={getFoodCategoryName(category)}
          onRemoveFilter={() => {
            const newCategories = categoriesArray.filter((c) => c !== category);
            setFilters({
              food_categories: newCategories.length > 0 ? newCategories.join(',') : null,
              page: null
            });
          }}
          key={`category-${category}`}
        />
      );
    });
  }

  if (openNow) {
    filterList.push(
      <FilterItem
        name='Open Now'
        onRemoveFilter={() => setFilters({ open_now: null, page: null })}
        key='open-now'
      />
    );
  }

  if (tomorrow) {
    filterList.push(
      <FilterItem
        name='Open Tomorrow'
        onRemoveFilter={() => setFilters({ tomorrow: null, page: null })}
        key='open-tomorrow'
      />
    );
  }

  if (day) {
    const date = dayjs(day).tz('America/Los_Angeles').format('MMMM D, YYYY');
    filterList.push(
      <FilterItem
        name={`Open ${date}`}
        onRemoveFilter={() => setFilters({ day: null, page: null })}
        key={`day-${day}`}
      />
    );
  }

  return (
    <div className={styles.FilterList}>
      {filterList}
    </div>
  );
}

export default FilterList;
